<template>
    <div style="float:right" id="app_pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page" ref="pagination"
            :page-sizes="[5, 10, 15, 20 , 30 ]" :page-size="pageSize" layout="total, jumper, sizes, prev, pager, next" :total="total">
        </el-pagination>
    </div>
</template>
<script>
let num = 1;
export default {
    props:["total"],
    data() {
        return {
            page: 1, //当前页数
            pageSize : 10
        }
    },
    mounted() {
        $(document).on('change', '.el-pagination>.el-pagination__jump>.el-pagination__editor', function(e) {
            if(e.target.value == ""){
                e.target.value = num;
            }
        });
    },
    methods: {
        handleSizeChange(val) {
            this.pageSize = val;
            let p = Math.ceil(Number(this.total)/val);
            if(Number(p) < this.page){
                this.page = Number(p);
                this.$emit("paginationChange" , [ this.pageSize , Number(p)]);
            }else{
                this.$emit("paginationChange" , [ this.pageSize , this.page]);
            }
        },
        handleCurrentChange(val) {
            num = val;
            this.page = val;
            this.$emit("paginationChange" , [this.pageSize, this.page]);
        }
    }
}
</script>



// WEBPACK FOOTER //
// pagination.vue?07e1ed55